var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('span',{staticClass:"app-icon",class:[
    { 'app-icon--with-background': _vm.backgroundColor },
    ("app-icon--" + _vm.size) ],style:({ 'background-color': _vm.icon && _vm.backgroundColor }),attrs:{"role":"presentation"},domProps:{"innerHTML":_vm._s(_vm.icon)}}):_c('span',{staticClass:"app-icon app-icon--default",class:[
    { 'app-icon--with-background': _vm.backgroundColor },
    ("app-icon--" + _vm.size) ],style:({ 'background-color': _vm.icon && _vm.backgroundColor }),attrs:{"role":"presentation"}})}
var staticRenderFns = []

export { render, staticRenderFns }